import {
  BasicTableSettings,
  RefreshableTableSettings,
  SettableColumnsTableSettings,
  MultiSelectTableSettings,
  multiSelectSettings,
  createPersistedStore,
  hiddenColumnsSettings,
  refreshableSettings,
} from '@@/datatables/types';

export interface TableSettings
  extends BasicTableSettings,
    SettableColumnsTableSettings,
    RefreshableTableSettings,
    MultiSelectTableSettings {}

export function createStore(
  storageKey: string,
  initalHiddenColumns: string[] = []
) {
  return createPersistedStore<TableSettings>(storageKey, 'name', (set) => ({
    ...hiddenColumnsSettings(set, initalHiddenColumns),
    ...refreshableSettings(set, 10),
    ...multiSelectSettings(set, false),
  }));
}
